import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';
export class Controller {

	/** @ngInject */
	constructor(
		$state,
		$rootScope,
		SharingSettingsService,
		Alert
	) {
		this.$state = $state;
		this.$rootScope  = $rootScope;
		this.SharingSettingsService = SharingSettingsService;
		this.Alert = Alert;
		// console.log(this);
		//this.settingsDetails.then(result=>{this.labels=result.companyLabels; this.settings=result.companySettings;});
		// this.settings=this.settingsDetails.companySettings;


	}



	$onInit() {
		this.labels = this.settingsDetails.companyLabels;
		this.resetSettings();
	}

	getLabelsMapLength(){
	var theKeys=Object.keys(this.settings.labelsMap);
	return theKeys.length;
	}
	resetSettings() {
		this.settings = angular.copy(this.settingsDetails.companySettings);
		this.allUsersShare = this.getLabelsMapLength() == 1 && this.settings.labelsMap["ALL_USERS"] !== undefined;
		//this.sharings = this.settings.labelsMap;
	}
	saveSettings() {
		if (this.settings.allowShare && this.getLabelsMapLength() === 0) {
			this.Alert('danger', 'must_choose_labels');
		} else {
			var companyId = this.$state.params.companyId;
			this.SharingSettingsService.saveSettings({ companyId }, this.settings).$promise.then(() => {
				this.goBack();
				this.Alert('success', 'saaspass_connect.create_success');
			})
			.catch((error) => {
					this.Alert('danger', error.data.message);
				});
		}
	}

	letUserChoosesOtpVisibility() {
		this.settings.showOtpEnabled = false;
	}
	letUserChoosesPassVisibility() {
		this.settings.showPasswordEnabled = false;
	}
	mainSettingChange() {
		if (!this.settings.allowShare) {
			this.settings.labelsMap = {};
			this.settings.showPasswordEnabled = false;
			this.settings.showOtpEnabled = false;
			this.settings.userChoosesPassVisibility = false;
			this.settings.userChoosesOtpVisibility = false;
		}
	}

	changeToAllShare() {
		//if(this.allUsersShare){
		this.settings.labelsMap = { "ALL_USERS": [] };
	}
	changeToLabelsShare() {
		this.settings.labelsMap = {};

	}
	isItCheckedAsShared(keyName, subLabel) {
		delete subLabel.$$hashKey;
		var list = this.settings.labelsMap[keyName];
		var isIt = false;//this.sharings[keyName].indexOf(subLabel)>=0;
		list.forEach((listItem) => { if (listItem.name === subLabel.name) isIt = true; });
		return isIt;
	}
	checkboxShareWithLabelChange(subLabel, keyName) {
		var subLabelIndex = this.settings.labelsMap[keyName].findIndex((item) => item.name === subLabel.name);
		if (subLabelIndex >= 0) {
			this.settings.labelsMap[keyName].splice(subLabelIndex, 1);
		} else {
			delete subLabel.$$hashKey;
			if (subLabel.name === "ALL_USERS"){
				this.settings.labelsMap[keyName]  = [subLabel];
			} else {
				this.settings.labelsMap[keyName].push(subLabel);
			}
		}
	}

	isCheckboxInTableDisabled(subLabel, keyName) {
		var isIt = (subLabel.name !== "ALL_USERS") && (this.settings.labelsMap[keyName].length === 1) && (this.settings.labelsMap[keyName][0].name === "ALL_USERS");
		return isIt;
	}
	changeInAllowShare() {
		this.settings.allowShare = !this.settings.allowShare;
	}

	checkboxSharingLabelChange(labelName) {
		if (this.settings.labelsMap[labelName] === undefined) {
			this.settings.labelsMap[labelName] = [];
		} else {
			this.removeSharing(labelName);
		}
	}
	removeSharing(keyName) {
		delete this.settings.labelsMap[keyName];
	}
	goBack() {
		var goToState = this.$rootScope.transition.from();
		var theState = goToState.name;
		if (theState === "") {
			theState = goToState.url;
		}
		this.$state.go(theState);
	}



}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-settings/sharing-settings.controller.js